import { useRef } from "react";
import { Close, TagCloseContainer, TagItem, TagNameContainer } from "../../index.styled";
import { useDrag, useDrop } from "react-dnd";
import { Tag } from "../../../../../../../models/common/tag.model";
import { RiCloseFill } from "react-icons/ri";

interface DraggableTagProps {
  tag: Tag;
  index: number;
  moveTag: (dragIndex: number, hoverIndex: number) => void;
  handleRemoveTag: (tag: Tag) => void;
  width?: string;
}

const DraggableTag: React.FC<DraggableTagProps> = ({
  tag,
  index,
  moveTag,
  handleRemoveTag,
  width='fit-content',
}) => {
  const ref = useRef(null);
  const ItemType = {
    TAG: "TAG",
  };

  const [, drop] = useDrop({
    accept: ItemType.TAG,
    hover: (item: any, monitor) => {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      moveTag(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemType.TAG,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <TagItem
      ref={ref}
      style={{ opacity: isDragging ? 0.5 : 1, width: width }}
      color={tag.color}
    >
      <TagNameContainer>{tag.name}</TagNameContainer>
      <TagCloseContainer color={tag.color} onClick={() => handleRemoveTag(tag)}>
        <Close color={tag.color}>
          <RiCloseFill />
        </Close>
      </TagCloseContainer>
    </TagItem>
  );
};

export default DraggableTag;
